// extracted by mini-css-extract-plugin
export default {"productGrid":"MZ-z","centerLink":"NZ-z","productSection":"OZ-z","item":"PZ-z","ctaButton":"QZ-z"};